import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import ClientUsers from './ClientUsers'
import Style from './users.module.css'
import PageLoader from '../../SharedComponents/PageState/PageLoader'
import PageNotice from '../../SharedComponents/PageState/PageNotice'
import { CLIENT_PERMISSION } from '../../../features/clientUsers/clientAccess'
import { clientGrants, useMyClients } from '../../../features/clientUsers/useClientAccess'
import { PATH } from '../../../app/routes'

const Users = () => {
    const { clients, isLoading } = useMyClients()
    const [selectedId, setSelectedId] = useState(null)

    if (isLoading) {
        return <PageLoader message="Loading users..." />
    }

    const manageable = clients.filter((item) => clientGrants(item, CLIENT_PERMISSION.USER_READ))
    const client = manageable.find((item) => item.id === selectedId) || manageable[0]
    if (!client) {
        return (
            <PageNotice
                icon="uil-lock-alt"
                title="You don't have permission to view users"
                hint="Ask an owner or admin of your account if you need access."
                linkTo={PATH.DASHBOARD}
                linkLabel="Go to Dashboard"
            />
        )
    }

    return (
        <div className="main-content mn-dashboard">
            <div className="page-content custompaddingdash">
                <div className={`container-fluid ${Style.page}`}>
                    <header className={Style.header}>
                        <ol className={`breadcrumb ${Style.breadcrumb}`}>
                            <li className="breadcrumb-item"><Link to={PATH.DASHBOARD}>Dashboard</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Users</li>
                        </ol>
                        <h1 className={Style.title}>Users</h1>
                        <p className={Style.subtitle}>People with access to this account and their roles</p>
                    </header>
                    {manageable.length > 1 ? (
                        <div className={Style.clientPicker}>
                            <label htmlFor="users-client" className={Style.fieldLabel}>Account</label>
                            <select
                                id="users-client"
                                className="form-control"
                                value={client.id}
                                onChange={(event) => setSelectedId(Number(event.target.value))}
                            >
                                {manageable.map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}
                            </select>
                        </div>
                    ) : null}
                    <ClientUsers key={client.id} client={client} />
                </div>
            </div>
        </div>
    )
}

export default Users
